<script>
  import { execution } from '../stores.js'
  import { SITE_MODE } from '../lib/hostSite.js'

  /** When true, show checklist even if MODE=paper (Live page). */
  export let force = false

  function mark(v) {
    if (v === true) return { ok: true, text: 'ок' }
    if (v === false) return { ok: false, text: 'нет' }
    return { ok: null, text: 'не проверено' }
  }

  $: onLiveHost = SITE_MODE === 'live'
  $: show =
    force ||
    onLiveHost ||
    ($execution &&
      ($execution.live_confirm_required ||
        ($execution.execution_mode === 'live' && !$execution.live_confirm)))

  $: envName = ($execution && $execution.live_confirm_env) || 'LIVE_CONFIRM'
  $: pf = ($execution && $execution.preflight) || {}
  $: modeLive =
    onLiveHost ||
    ($execution && ($execution.execution_mode === 'live' || $execution.live_15m_unit_active))
  $: rows = show
    ? [
        { label: 'On-chain READY (wrap/approve)', ...mark(pf.onchain_ready ?? pf.pusd_ok) },
        { label: 'Signer на VPS (bool)', ...mark(pf.signer_configured) },
        { label: 'L2 POLY_API_* (bool)', ...mark(pf.l2_creds_present) },
        {
          label: `${envName}=yes`,
          ...mark(pf.live_confirm_ok),
        },
        {
          label: 'kill switch отсутствует',
          ...mark(pf.kill_clear),
        },
      ]
    : []
</script>

{#if show}
  <section
    class="pm-preflight"
    role={modeLive ? 'alert' : 'status'}
    aria-label={modeLive ? 'Требуется подтверждение' : 'Префлайт live'}
  >
    <h2 class="pm-preflight__title">
      {#if modeLive}
        Живая торговля · префлайт
      {:else}
        Live выключен (бумага)
      {/if}
    </h2>
    <p class="pm-preflight__body">
      {#if modeLive}
        Хост <strong>live</strong> · unit <code>pmbot-live-15m</code>.
        Ордера с UI всё равно не шлём — только статус и управление unit.
      {:else}
        Режим из конфига: <strong>БУМАГА</strong>. Реальный POST /order не активен.
        Чеклист — подготовка к smoke. Ждём явное «можно smoke», не кнопку «включить live».
      {/if}
    </p>
    <ul class="pm-preflight__list">
      {#each rows as r}
        <li class:is-ok={r.ok === true} class:is-bad={r.ok === false} class:is-unk={r.ok === null}>
          <span class="pm-preflight__mark" aria-hidden="true">
            {r.ok === true ? '✓' : r.ok === false ? '✗' : '·'}
          </span>
          {r.label}
          <span class="pm-preflight__state">— {r.text}</span>
        </li>
      {/each}
    </ul>
  </section>
{/if}
